import { ArrowBack } from "@mui/icons-material";
import { Stack, Button } from "@mui/material";
import { useState } from "react";
import MatchesTable from "../pages/CityEscape/MatchesTable";
import { MatchDetailView } from "./MatchDetailView";

export function CityEscapeMatchesList({
  cityEscapeId,
  filters,
}: {
  cityEscapeId?: string;
  filters?: Record<string, any>;
}) {
  const [selectedMatchId, setSelectedMatchId] = useState<string | null>(null);

  if (selectedMatchId) {
    return (
      <Stack spacing={0}>
        <Button
          variant="text"
          style={{ width: "200px" }}
          onClick={() => setSelectedMatchId(null)}
        >
          <ArrowBack />
          Torna alla lista
        </Button>
        <MatchDetailView matchId={selectedMatchId} />
      </Stack>
    );
  }

  return (
    <Stack spacing={2}>
      <MatchesTable
        cityEscapeId={cityEscapeId}
        filters={filters}
        onRowDoubleClick={(params) => {
          console.log("Selected match id!:", params);
          setSelectedMatchId(params.row.id);
        }}
      />
    </Stack>
  );
}
